// extracted by mini-css-extract-plugin
export default {"details_categories_item":"style_details_categories_item__Sw1ch","details_simple":"style_details_simple__cvC8x"};